import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { UserFormData, userSchema } from '../../pages/UserManagement';
import { User } from '../../types/User';
import FormInput from '../FormsInput/FormInput';
import { ADMIN_ROLE_NAME, REPORTING_ONLY_ROLE_NAME, RETURN_MAIL_TEAM_ROLE_NAME } from '../../types/Role';

type Props = {
  user: User;
  onSave: (data: UserFormData) => void;
  isEditLoading: boolean;
};

const EditUserModal = (props: Props) => {
  const { user, onSave, isEditLoading } = props;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
  } = useForm<UserFormData>({
    resolver: zodResolver(userSchema),
    defaultValues: {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      role: user.role,
    },
  });

  //  Reset form when user changes
  useEffect(() => {
    reset({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      role: user.role,
    });
  }, [user, reset]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((err) => {
        toast.error(err.message as string);
      });
    }
  }, [errors]);
  const onSubmit = async (data: UserFormData) => {
    await onSave(data);
  };
  const closeModal = () => {
    //setUser(null);
    (document.getElementById('edit_modal') as HTMLFormElement)?.close();
  };

  return (
    <dialog id="edit_modal" className="modal">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Edit User</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-3" id="edit_form">
          <FormInput
            label="First Name"
            name="firstName"
            type="string"
            register={register('firstName')}
            errors={errors.firstName}
            touchedField={touchedFields.firstName}
            placeholder="first name"
            required
          />
          <FormInput
            label="Last Name"
            name="lastName"
            type="string"
            register={register('lastName')}
            errors={errors.lastName}
            touchedField={touchedFields.lastName}
            placeholder="lastName"
            required
          />
          <FormInput
            label="Email"
            name="email"
            type="string"
            register={register('email')}
            errors={errors.email}
            touchedField={touchedFields.email}
            placeholder="email"
          />

          <select {...register('role')} className="select select-bordered w-full">
            <option value={REPORTING_ONLY_ROLE_NAME}>{REPORTING_ONLY_ROLE_NAME}</option>
            <option value={RETURN_MAIL_TEAM_ROLE_NAME}>{RETURN_MAIL_TEAM_ROLE_NAME}</option>
            <option value={ADMIN_ROLE_NAME}>{ADMIN_ROLE_NAME}</option>
          </select>

          <div className="modal-action">
            <button type="submit" className="btn btn-success" disabled={isEditLoading}>
              {isEditLoading ? <span className="loading loading-spinner loading-md" /> : 'Save'}
            </button>
            <button type="button" className="btn btn-error" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </dialog>
  );
};

export default EditUserModal;
